import { useTheme } from '@/context/ThemeContext';
import { useEffect, useState } from 'react';
import { IoSunnyOutline, IoMoonOutline } from 'react-icons/io5';

const ThemeToggle = () => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <div className="light-dark-mode leading-0">
      <button 
        onClick={toggleTheme}
        className="cursor-pointer"
        aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      >
        {isDark ? (
          <IoSunnyOutline className="text-2xl text-yellow-300" />
        ) : (
          <IoMoonOutline className="text-2xl text-gray-700" />
        )}
      </button>
    </div>
  );
};

export default ThemeToggle;